import * as React from 'react';
const Search = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M9 0a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 9 0ZM3 9a6 6 0 1 1 12 0A6 6 0 0 1 3 9Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default Search;
